import { Builder } from '@builder.io/react';
import Text from './text';
import theme from '../../gatsby-plugin-theme-ui-v1';

Builder.registerComponent(Text, {
  name: 'Text',
  static: true,
  inputs: [
    {
      name: 'text',
      type: 'html',
      required: true,
      autofocus: true,
      defaultValue: 'Enter some text...',
    },
    {
      name: 'textAlign',
      type: 'string',
      required: false,
      enum: [
        'start',
        'center',
        'end',
        'justify',
        'justify-all',
        'match-parent',
      ],
      defaultValue: 'start',
    },
    {
      name: 'textStyles',
      type: 'string',
      enum: theme.styles.textStyles,
      defaultValue: 'default',
    },
    {
      name: 'textColor',
      type: 'string',
      enum: theme.styles.textColors,
      defaultValue: 'default',
    },
    {
      name: 'textColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
  ],
});
